// @flow

import React from 'react';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { toastr } from 'react-redux-toastr';
import rootReducer from './rootReducer';
import Loader from '../components/commons/loader/loader';

const analyticsMiddleware = store => next => action => {
  const analyticsdata = action.payload && action.payload.analyticsdata;
  const state = store.getState();
  const userProfile = state && state.userProfile;
  if (analyticsdata && typeof analyticsdata === 'object') {
    if (window.gtag) {
      window.gtag(
        'event',
        analyticsdata.eventName || analyticsdata.event_action,
        Object.assign(analyticsdata, {
          userId: userProfile && userProfile.email,
          userLocation: userProfile && userProfile.location_code,
          userOrg: userProfile && userProfile.organizationId
        })
      );
    }
  }
  next(action);
};

const boomerang = () => next => action => {
  // ZT-3099 --- This mid ware is for api loading,loaded,failure handling. With time this method is bound to get bigger
  const data = action.payload && action.payload.boomerang;
  if (data) {
    let { component, heading, message, type } = data;
    const { removeExistingBms, timeOut, iconType } = data;
    component = component || 'toastr'; // default is loader. Allowed types - fetching, success, info, warning, etc etc
    if (component === 'toastr') {
      const options = {
        timeOut,
        icon: iconType === 'loader' ? <Loader /> : null,
        status: 'warning'
      };
      if (removeExistingBms) {
        toastr.removeByType('success');
        toastr.removeByType('error');
        toastr.removeByType('light');
        toastr.removeByType('info');
      }
      message = message || '';
      type = type || '';
      if (type === 'fetching' || type === 'info') {
        heading = heading || 'Please wait';
        toastr.light(heading, message, options);
      } else if (type === 'success') {
        heading = heading || 'Success';
        toastr.success(heading, message, options);
      } else if (type === 'error') {
        heading = heading || 'Error';
        toastr.error(heading, message, options);
      } else {
        // default
        heading = heading || 'Please wait';
        toastr.light(heading, message, options);
      }
    }
  }
  next(action);
};

const middleware = applyMiddleware(thunk, analyticsMiddleware, boomerang);

const getStore = (isClient: boolean) =>
  isClient
    ? createStore(
        rootReducer,
        window.INITIAL_STATE,
        compose(
          middleware,
          window.devToolsExtension ? window.devToolsExtension() : f => f
        )
      )
    : createStore(
        rootReducer,
        compose(
          middleware,
          window.devToolsExtension ? window.devToolsExtension() : f => f
        )
      );

export default getStore;
